import axios from './base'
const url = '/tasks'
// ==================== 项目管理 ====================

export function getProjects(params) {
  return axios.request({
    url: `${url}/projects`,
    method: 'get',
    params
  })
}

// 获取全部项目列表（不分页，用于下拉选择）
export function getAllProjects(params) {
  return axios.request({
    url: `${url}/projects/all`,
    method: 'get',
    params
  })
}

export function getProjectDetail(id) {
  return axios.request({
    url: `${url}/projects/${id}`,
    method: 'get'
  })
}

export function createProject(data) {
  return axios.request({
    url: `${url}/projects`,
    method: 'post',
    data
  })
}

export function updateProject(id, data) {
  return axios.request({
    url: `${url}/projects/${id}`,
    method: 'put',
    data
  })
}

export function deleteProject(id) {
  return axios.request({
    url: `${url}/projects/${id}`,
    method: 'delete'
  })
}

// ==================== 看板管理 ====================

export function getBoards(params) {
  return axios.request({
    url: `${url}/boards`,
    method: 'get',
    params
  })
}

export function getBoardDetail(id) {
  return axios.request({
    url: `${url}/boards/${id}`,
    method: 'get'
  })
}

export function createBoard(data) {
  return axios.request({
    url: `${url}/boards`,
    method: 'post',
    data
  })
}

export function updateBoard(id, data) {
  return axios.request({
    url: `${url}/boards/${id}`,
    method: 'put',
    data
  })
}

export function deleteBoard(id) {
  return axios.request({
    url: `${url}/boards/${id}`,
    method: 'delete'
  })
}

// ==================== 列管理 ====================

export function createColumn(data) {
  return axios.request({
    url: `${url}/columns`,
    method: 'post',
    data
  })
}

export function updateColumn(id, data) {
  return axios.request({
    url: `${url}/columns/${id}`,
    method: 'put',
    data
  })
}

export function deleteColumn(id) {
  return axios.request({
    url: `${url}/columns/${id}`,
    method: 'delete'
  })
}

// ==================== 任务管理 ====================

export function getTaskDetail(id) {
  return axios.request({
    url: `${url}/tasks/${id}`,
    method: 'get'
  })
}

export function createTask(data) {
  return axios.request({
    url: `${url}/tasks`,
    method: 'post',
    data
  })
}

export function updateTask(id, data) {
  return axios.request({
    url: `${url}/tasks/${id}`,
    method: 'put',
    data
  })
}

export function deleteTask(id) {
  return axios.request({
    url: `${url}/tasks/${id}`,
    method: 'delete'
  })
}

export function moveTask(id, data) {
  return axios.request({
    url: `${url}/tasks/${id}/move`,
    method: 'post',
    data
  })
}

// ==================== 标签管理 ====================

export function getLabels(params) {
  return axios.request({
    url: `${url}/labels`,
    method: 'get',
    params
  })
}

export function createLabel(data) {
  return axios.request({
    url: `${url}/labels`,
    method: 'post',
    data
  })
}
